// The Studio's own face for words drawn on a canvas: game cases, a device's
// idle card, the laptop's first frame. The pages' stylesheets name the same
// family (web/assets/type.css serves it), and a canvas draws with whatever
// face is loaded at that moment, so a drawing waits for `faceReady` first or
// it gets the fallback and keeps it.

const FAMILY = `"Gabarito", system-ui, sans-serif`;

/** A canvas `font` value in the Studio's face. 900 is for names and titles, 700 for labels, 600 for sentences. */
export function face(weight: 600 | 700 | 900, pixels: number): string {
  return `${weight} ${pixels}px ${FAMILY}`;
}

/**
 * Resolves once the face can draw `text`. The family is one variable file a
 * script, so one weight is asked for; the text decides which scripts' files
 * are fetched. A face that fails to load does not hold the drawing.
 */
export async function faceReady(text = ""): Promise<void> {
  await document.fonts.load(face(900, 32), text).catch(() => null);
}
